// CAROUSEL
import masterclass_Ganci_03062025_carousel from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_carousel.webp";
import locandina_cross_polo_sound_2025 from "./cross_polo_sound_2025/locandina_cross_polo_sound_2025.webp";

// FULL

// masterclass_Ganci_03062025
import masterclass_Ganci_03062025_1 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_1.webp";
import masterclass_Ganci_03062025_2 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_2.webp";
import masterclass_Ganci_03062025_3 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_3.webp";
import masterclass_Ganci_03062025_4 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_4.webp";
import masterclass_Ganci_03062025_5 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_5.webp";
import masterclass_Ganci_03062025_6 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_6.webp";
import masterclass_Ganci_03062025_7 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_7.webp";
import masterclass_Ganci_03062025_8 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_8.webp";
import masterclass_Ganci_03062025_9 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_9.webp";
import masterclass_Ganci_03062025_10 from "./masterclass_Ganci_03062025/masterclass_Ganci_03062025_10.webp";

// CPS_2025
import cps_2025_1 from "./cross_polo_sound_2025/cps_2025_1.webp";
import cps_2025_2 from "./cross_polo_sound_2025/cps_2025_2.webp";
import cps_2025_3 from "./cross_polo_sound_2025/cps_2025_3.webp";
import cps_2025_4 from "./cross_polo_sound_2025/cps_2025_4.webp";
import cps_2025_5 from "./cross_polo_sound_2025/cps_2025_5.webp";
import cps_2025_6 from "./cross_polo_sound_2025/cps_2025_6.webp";
import cps_2025_7 from "./cross_polo_sound_2025/cps_2025_7.webp";
import cps_2025_8 from "./cross_polo_sound_2025/cps_2025_8.webp";
import cps_2025_9 from "./cross_polo_sound_2025/cps_2025_9.webp";
import cps_2025_10 from "./cross_polo_sound_2025/cps_2025_10.webp";
import cps_2025_11 from "./cross_polo_sound_2025/cps_2025_11.webp";
import cps_2025_12 from "./cross_polo_sound_2025/cps_2025_12.webp";
import cps_2025_13 from "./cross_polo_sound_2025/cps_2025_13.webp";
import cps_2025_14 from "./cross_polo_sound_2025/cps_2025_14.webp";
import cps_2025_15 from "./cross_polo_sound_2025/cps_2025_15.webp";
import cps_2025_16 from "./cross_polo_sound_2025/cps_2025_16.webp";
import cps_2025_17 from "./cross_polo_sound_2025/cps_2025_17.webp";
import cps_2025_18 from "./cross_polo_sound_2025/cps_2025_18.webp";
import cps_2025_19 from "./cross_polo_sound_2025/cps_2025_19.webp";
import cps_2025_20 from "./cross_polo_sound_2025/cps_2025_20.webp";
import cps_2025_21 from "./cross_polo_sound_2025/cps_2025_21.webp";

// CR_03032026
import cr_03032026_1 from "./conservatorio_repice_03032026/cr_03032026_1.webp";
import cr_03032026_2 from "./conservatorio_repice_03032026/cr_03032026_2.webp";
import cr_03032026_3 from "./conservatorio_repice_03032026/cr_03032026_3.webp";
import cr_03032026_4 from "./conservatorio_repice_03032026/cr_03032026_4.webp";
import cr_03032026_5 from "./conservatorio_repice_03032026/cr_03032026_5.webp";
import cr_03032026_6 from "./conservatorio_repice_03032026/cr_03032026_6.webp";
import cr_03032026_7 from "./conservatorio_repice_03032026/cr_03032026_7.webp";
import cr_03032026_8 from "./conservatorio_repice_03032026/cr_03032026_8.webp";
import cr_03032026_9 from "./conservatorio_repice_03032026/cr_03032026_9.webp";

// THUMBNAILS

// masterclass_Ganci_03062025
import masterclass_Ganci_03062025_1_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_1.webp";
import masterclass_Ganci_03062025_2_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_2.webp";
import masterclass_Ganci_03062025_3_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_3.webp";
import masterclass_Ganci_03062025_4_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_4.webp";
import masterclass_Ganci_03062025_5_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_5.webp";
import masterclass_Ganci_03062025_6_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_6.webp";
import masterclass_Ganci_03062025_7_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_7.webp";
import masterclass_Ganci_03062025_8_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_8.webp";
import masterclass_Ganci_03062025_9_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_9.webp";
import masterclass_Ganci_03062025_10_t from "./masterclass_Ganci_03062025/thumbnails/masterclass_Ganci_03062025_10.webp";

// CPS_2025
import cps_2025_1_t from "./cross_polo_sound_2025/thumbnails/cps_2025_1.webp";
import cps_2025_2_t from "./cross_polo_sound_2025/thumbnails/cps_2025_2.webp";
import cps_2025_3_t from "./cross_polo_sound_2025/thumbnails/cps_2025_3.webp";
import cps_2025_4_t from "./cross_polo_sound_2025/thumbnails/cps_2025_4.webp";
import cps_2025_5_t from "./cross_polo_sound_2025/thumbnails/cps_2025_5.webp";
import cps_2025_6_t from "./cross_polo_sound_2025/thumbnails/cps_2025_6.webp";
import cps_2025_7_t from "./cross_polo_sound_2025/thumbnails/cps_2025_7.webp";
import cps_2025_8_t from "./cross_polo_sound_2025/thumbnails/cps_2025_8.webp";
import cps_2025_9_t from "./cross_polo_sound_2025/thumbnails/cps_2025_9.webp";
import cps_2025_10_t from "./cross_polo_sound_2025/thumbnails/cps_2025_10.webp";
import cps_2025_11_t from "./cross_polo_sound_2025/thumbnails/cps_2025_11.webp";
import cps_2025_12_t from "./cross_polo_sound_2025/thumbnails/cps_2025_12.webp";
import cps_2025_13_t from "./cross_polo_sound_2025/thumbnails/cps_2025_13.webp";
import cps_2025_14_t from "./cross_polo_sound_2025/thumbnails/cps_2025_14.webp";
import cps_2025_15_t from "./cross_polo_sound_2025/thumbnails/cps_2025_15.webp";
import cps_2025_16_t from "./cross_polo_sound_2025/thumbnails/cps_2025_16.webp";
import cps_2025_17_t from "./cross_polo_sound_2025/thumbnails/cps_2025_17.webp";
import cps_2025_18_t from "./cross_polo_sound_2025/thumbnails/cps_2025_18.webp";
import cps_2025_19_t from "./cross_polo_sound_2025/thumbnails/cps_2025_19.webp";
import cps_2025_20_t from "./cross_polo_sound_2025/thumbnails/cps_2025_20.webp";
import cps_2025_21_t from "./cross_polo_sound_2025/thumbnails/cps_2025_21.webp";

// CR_03032026
import cr_03032026_1_t from "./conservatorio_repice_03032026/cr_03032026_1.webp";
import cr_03032026_2_t from "./conservatorio_repice_03032026/cr_03032026_2.webp";
import cr_03032026_3_t from "./conservatorio_repice_03032026/cr_03032026_3.webp";
import cr_03032026_4_t from "./conservatorio_repice_03032026/cr_03032026_4.webp";
import cr_03032026_5_t from "./conservatorio_repice_03032026/cr_03032026_5.webp";
import cr_03032026_6_t from "./conservatorio_repice_03032026/cr_03032026_6.webp";
import cr_03032026_7_t from "./conservatorio_repice_03032026/cr_03032026_7.webp";
import cr_03032026_8_t from "./conservatorio_repice_03032026/cr_03032026_8.webp";
import cr_03032026_9_t from "./conservatorio_repice_03032026/cr_03032026_9.webp";

export const eventImages = {
    masterclass_Ganci_03062025: {
        carousel: {
            desktop: masterclass_Ganci_03062025_carousel,
            mobile: masterclass_Ganci_03062025_carousel
        },
        detail: [
            { full: masterclass_Ganci_03062025_1, thumb: masterclass_Ganci_03062025_1_t },
            { full: masterclass_Ganci_03062025_2, thumb: masterclass_Ganci_03062025_2_t },
            { full: masterclass_Ganci_03062025_3, thumb: masterclass_Ganci_03062025_3_t },
            { full: masterclass_Ganci_03062025_4, thumb: masterclass_Ganci_03062025_4_t },
            { full: masterclass_Ganci_03062025_5, thumb: masterclass_Ganci_03062025_5_t },
            { full: masterclass_Ganci_03062025_6, thumb: masterclass_Ganci_03062025_6_t },
            { full: masterclass_Ganci_03062025_7, thumb: masterclass_Ganci_03062025_7_t },
            { full: masterclass_Ganci_03062025_8, thumb: masterclass_Ganci_03062025_8_t },
            { full: masterclass_Ganci_03062025_9, thumb: masterclass_Ganci_03062025_9_t },
            { full: masterclass_Ganci_03062025_10, thumb: masterclass_Ganci_03062025_10_t },
        ]
    },
    cps_2026: {
        carousel: {
            desktop: locandina_cross_polo_sound_2025,
            mobile: locandina_cross_polo_sound_2025
        },
        detail: [
            { full: cps_2025_1, thumb: cps_2025_1_t },
            { full: cps_2025_2, thumb: cps_2025_2_t },
            { full: cps_2025_3, thumb: cps_2025_3_t },
            { full: cps_2025_4, thumb: cps_2025_4_t },
            { full: cps_2025_5, thumb: cps_2025_5_t },
            { full: cps_2025_6, thumb: cps_2025_6_t },
            { full: cps_2025_7, thumb: cps_2025_7_t },
            { full: cps_2025_8, thumb: cps_2025_8_t },
            { full: cps_2025_9, thumb: cps_2025_9_t },
            { full: cps_2025_10, thumb: cps_2025_10_t },
            { full: cps_2025_11, thumb: cps_2025_11_t },
            { full: cps_2025_12, thumb: cps_2025_12_t },
            { full: cps_2025_13, thumb: cps_2025_13_t },
            { full: cps_2025_14, thumb: cps_2025_14_t },
            { full: cps_2025_15, thumb: cps_2025_15_t },
            { full: cps_2025_16, thumb: cps_2025_16_t },
            { full: cps_2025_17, thumb: cps_2025_17_t },
            { full: cps_2025_18, thumb: cps_2025_18_t },
            { full: cps_2025_19, thumb: cps_2025_19_t },
            { full: cps_2025_20, thumb: cps_2025_20_t },
            { full: cps_2025_21, thumb: cps_2025_21_t },
        ]
    },
    cr_032026: {
        carousel: {
            desktop: cr_03032026_2,
            mobile: cr_03032026_2
        },
        detail: [
            { full: cr_03032026_1, thumb: cr_03032026_1_t },
            { full: cr_03032026_2, thumb: cr_03032026_2_t },
            { full: cr_03032026_3, thumb: cr_03032026_3_t },
            { full: cr_03032026_4, thumb: cr_03032026_4_t },
            { full: cr_03032026_5, thumb: cr_03032026_5_t },
            { full: cr_03032026_6, thumb: cr_03032026_6_t },
            { full: cr_03032026_7, thumb: cr_03032026_7_t },
            { full: cr_03032026_8, thumb: cr_03032026_8_t },
            { full: cr_03032026_9, thumb: cr_03032026_9_t },
        ]
    }
};